"use client"

// src/ripple.tsx
import { AnimatePresence, motion } from "@yamada-ui/motion";
import { cx, handlerAll } from "@yamada-ui/utils";
import { Fragment, jsx } from "react/jsx-runtime";
var clamp = (value, min, max) => Math.min(Math.max(value, min), max);
var Ripple = ({
  className,
  style,
  color = "currentColor",
  isDisabled,
  disabled = isDisabled,
  ripples,
  onAnimationComplete,
  onClear,
  ...rest
}) => {
  if (disabled) return null;
  const css = {
    rounded: "fallback(full, 9999px)",
    zIndex: "fallback(kurillin, 9)"
  };
  return /* @__PURE__ */ jsx(Fragment, { children: ripples.map(({ key, size, x, y }) => {
    const duration = clamp(0.01 * size, 0.2, size > 100 ? 0.75 : 0.5);
    return /* @__PURE__ */ jsx(AnimatePresence, { mode: "popLayout", children: /* @__PURE__ */ jsx(
      motion.span,
      {
        className: cx("ui-ripple", className),
        style: {
          height: `${size}px`,
          left: x,
          pointerEvents: "none",
          position: "absolute",
          top: y,
          transformOrigin: "center",
          width: `${size}px`,
          ...style
        },
        animate: { opacity: 0, transform: "scale(2)" },
        bgColor: color,
        exit: { opacity: 0 },
        initial: { opacity: 0.35, transform: "scale(0)" },
        transition: { duration },
        __css: css,
        ...rest,
        onAnimationComplete: handlerAll(
          onAnimationComplete,
          () => onClear(key)
        )
      }
    ) }, key);
  }) });
};
Ripple.displayName = "Ripple";
Ripple.__ui__ = "Ripple";

export {
  Ripple
};
//# sourceMappingURL=chunk-FQZLN724.mjs.map